import { useTranslation } from "react-i18next";
import Input from "../../../components/form-controls/Input"
import { useEffect, useState } from "react";

function QuickReplyBtn({ errors, register, watch, index, onDelete, type }) {

    const { t } = useTranslation();
   
    return (
        <div className="">
            <div className="mb-2">
                { type === 'QUICK_REPLY' && <><i className={`bi bi-send text-primary me-2 `} /> {t("platform.channels.templates.quick-response")}</>}
                { type === 'QUICK_REPLY_DISABLE_MKT' && <><i className={`bi bi-send text-success me-2 `} /> Desactivar envio de plantillas</>}
            </div>
            <div className="d-flex align-items-center">
                <div className="flex-grow-1 me-2 meta-btn-container text-white-dark bg-soft-info-alternative">
                    <Input
                        label={t("platform.channels.templates.text-btn")}
                        errors={errors} {...register(`buttons.buttons.${index}.text`, { required: true, maxLength: { value: 25, message: '25' }, setValueAs: (value) => value.trim() })}
                        currentLength={watch(`buttons.buttons.${index}.text`).length}
                        maxLength={25}
                    />

                    {
                         type === 'QUICK_REPLY_DISABLE_MKT' && (
                            <>            
                                <div className="alert alert-warning">
                                    <p className="m-0">Desactivar envio de plantillas permite al usuario desactivar todos los mensajes de plantilla cuando no hay una conversación abierta. Solo se permitirá enviar mensajes una vez que el usuario inicie una conversación. Esto puede ayudar a reducir los bloqueos de clientes y mejorar tu calificación de calidad.</p>
                                </div>
                            </>
                         )
                    }
                </div>

                <div>
                    <button type="button" className="btn btn-ghost-danger btn-icon" onClick={onDelete}><i className="bi-x-lg"></i></button>
                </div>
            </div>
            <hr className="my-3" />
        </div>
    )
}
export default QuickReplyBtn